module.exports = __webpack_public_path__ + "img/taiqianAppImage.4b406a61.png";